import styled from 'styled-components';

export const ContestStepCircleHeadline = styled.div`
    font-size:  ${( { theme }) => theme.fontSizeXS };
`;

export default ContestStepCircleHeadline;
